export const ADD_MONTH = 'ADD_MONTH';
export const ADD_AUTO = 'ADD_AUTO';
export const ADD_COMMENT = 'ADD_COMMENT';
export const ADD_ADVENTURE = 'ADD_ADVENTURE';
export const DISHES_LOADING = 'DISHES_LOADING';
export const ADD_DISHES = 'ADD_DISHES';
export const DISHES_FAILED = 'DISHES_FAILED';
export const ADD_MONTHS = 'ADD_MONTHS';
export const MONTHS_FAILED = 'MONTHS_FAILED';
export const ADD_AUTOS = 'ADD_AUTOS';
export const AUTOS_FAILED = 'AUTOS_FAILED';
export const ADD_COMMENTS = 'ADD_COMMENTS';
export const COMMENTS_FAILED = 'COMMENTS_FAILED';
export const FINANCES_LOADING = 'FINANCES_LOADING';
export const ADD_FINANCES = 'ADD_FINANCES';
export const FINANCES_FAILED = 'FINANCES_FAILED';
export const ADVENTURES_LOADING = 'ADVENTURES_LOADING';
export const ADD_ADVENTURES = 'ADD_ADVENTURES';
export const ADVENTURES_FAILED = 'ADVENTURES_FAILED';
export const CARDS_LOADING = 'CARDS_LOADING';
export const ADD_CARDS = 'ADD_CARDS';
export const CARDS_FAILED = 'CARDS_FAILED';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';


// WEBPACK FOOTER //
// ./src/redux/ActionTypes.js